import React, { useCallback, useMemo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import { DeleteIcon, EditPenIcon, ResetIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';
import { getConditionalArray } from 'utils/data';

import { PaymentStatusEnum } from '../../Servicing.constants';

const ActionButton = ({ row, onEdit, onDelete, onReverse, disabled = false }) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const isReversed = row.paymentStatus === PaymentStatusEnum.REVERSED;

  const onClickEdit = useCallback(() => {
    onClearAnchorElement();
    onEdit(row);
  }, [onClearAnchorElement, onEdit, row]);

  const onClickDelete = useCallback(() => {
    onClearAnchorElement();
    onDelete(row);
  }, [onClearAnchorElement, onDelete, row]);

  const onClickReverse = useCallback(() => {
    onClearAnchorElement();
    onReverse(row);
  }, [onClearAnchorElement, onReverse, row]);

  const items = useMemo(
    () => [
      ...getConditionalArray(!isReversed, [
        { text: 'Edit', onClick: onClickEdit, icon: <EditPenIcon size={IconSize[20]} /> },
        { text: 'Reverse', onClick: onClickReverse, icon: <ResetIcon size={IconSize[20]} /> },
      ]),
      { text: 'Delete', onClick: onClickDelete, icon: <DeleteIcon size={IconSize[20]} /> },
    ],
    [onClickEdit, onClickDelete, onClickReverse, isReversed],
  );

  return (
    <>
      <MoreButtonCDS disabled={disabled} isSelected={!!anchorEl} onClick={onSetAnchorElement} />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

ActionButton.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onReverse: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ActionButton;
